import { time } from '@/components/Functional/utils/util'
import { Image } from '@/components/UI'
import { Skeleton } from '@/components/UI/Skeleton'
import type { DateTimeString } from '@/schemas/v2'
import { IconBookmark, IconHelp } from '@tabler/icons-react'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { EventPeriod } from './EventPeriod'

const nowISODate = () => {
  return new Date().toISOString()
}

/**
 * `Raund-Replace / Screen UI / TOP-案1`
 * */
export const CampaignComponents = memo(
  ({
    image,
    viewStartAt,
    viewEndAt,
    period = true,
    isDisplayEventPeriod,
    showCampaignDescription = true,
    isLoading = false,
    onClickSummary,
    onClickHowToPlay,
  }: {
    image: string
    viewStartAt: DateTimeString | null | undefined
    viewEndAt: DateTimeString | null | undefined
    isDisplayEventPeriod?: boolean
    period?: boolean
    showCampaignDescription?: boolean
    isLoading?: boolean
    onClickSummary?: () => void
    onClickHowToPlay?: () => void
  }) => {
    const { t, i18n } = useTranslation()
    const date = nowISODate()
    const startAt = viewStartAt ?? ''
    const endAt = viewEndAt ?? ''

    return (
      <>
        {image ? (
          <Image src={image} fit="width-fit" />
        ) : (
          <div className="w-full h-[250px]">
            <Skeleton variant="rect" height={250} width={'100%'} />
          </div>
        )}

        <div className="mx-4 mt-[10px]">
          <div className="flex justify-center">
            {period && isDisplayEventPeriod && !startAt && !endAt && (
              <Skeleton variant="rect" height={24} width={'100%'} />
            )}
            {period && isDisplayEventPeriod && startAt && endAt && (
              <EventPeriod
                startDate={time({ time: startAt, language: i18n.language }) ?? ''}
                endDate={time({ time: endAt, language: i18n.language }) ?? ''}
              />
            )}
            {!period && isDisplayEventPeriod && startAt && endAt && new Date(startAt) > new Date(date) && (
              <EventPeriod
                startDate={time({ time: startAt, language: i18n.language }) ?? ''}
                endDate={time({ time: endAt, language: i18n.language }) ?? ''}
              />
            )}
            {!period && isDisplayEventPeriod && startAt && endAt && new Date(endAt) < new Date(date) && (
              <EventPeriod
                startDate={time({ time: startAt, language: i18n.language }) ?? ''}
                endDate={time({ time: endAt, language: i18n.language }) ?? ''}
              />
            )}
          </div>
          <div className="flex justify-end items-end gap-4 mt-[17px]">
            {isLoading ? (
              <>
                <div className="flex flex-col items-center gap-1">
                  <Skeleton variant="circle" width={24} height={24} />
                  <Skeleton variant="text" width={30} height={12} />
                </div>
                <div className="flex flex-col items-center gap-1">
                  <Skeleton variant="circle" width={24} height={24} />
                  <Skeleton variant="text" width={36} height={12} />
                </div>
              </>
            ) : (
              <>
                <button type="button" onClick={onClickSummary} className="flex flex-col items-center gap-0">
                  <IconBookmark size={24} className="text-[#757575]" />
                  <span className="text-[11px] font-bold text-[#757575]">{t('home.summary', '概要')}</span>
                </button>
                <button type="button" onClick={onClickHowToPlay} className="flex flex-col items-center gap-0">
                  <IconHelp size={24} className="text-[#757575]" />
                  <span className="text-[11px] font-bold text-[#757575]">{t('common.play', '遊び方')}</span>
                </button>
              </>
            )}
          </div>
        </div>
      </>
    )
  },
)
